<div class="shared-component" v-loading="isLoading">
	<component
		ref="component"
		v-if="isReady"
		:is="realComponentName"
		v-bind="$attrs"
		v-on="$listeners"
	/>
	<div v-if="isError && isLoaded" style="color:red">
		{{ $t('Error load shared component!') }}
	</div>
</div>
